import QRCodeView from 'qrcode.react';

export const QRCode = ({ value }) => {
  if (value) {
    return <QRCodeView value={value} />;
  }
  return null;
};
